// Item 216 batch 3 — SP certificate generation client. Backs the
// SetupWizard's SSO step "Generate SP certificate" action: every call
// mints a brand-new self-signed keypair server-side. Nothing is
// persisted — the operator downloads both PEMs, sets
// ORBITALREG_SAML_CERT_PEM / ORBITALREG_SAML_KEY_PEM, and restarts.

import { parseErrorResponse } from './problem';

export interface SAMLSPCertResult {
  cert_pem: string;
  key_pem: string;
  fingerprint_sha256: string;
  not_after: string;
}

export async function generateSAMLSPCert(commonName?: string): Promise<SAMLSPCertResult> {
  const res = await fetch('/api/admin/saml/sp-cert/generate', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ common_name: commonName ?? '' }),
  });
  if (!res.ok) throw await parseErrorResponse(res);
  return res.json();
}
